import { render, staticRenderFns } from "./UploadZone.vue?vue&type=template&id=4f9de505"
import script from "./UploadZone.vue?vue&type=script&lang=js"
export * from "./UploadZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports